import { NICE_BG_FOR_CARDS_HOVER } from './constants';

export const ONBOARDING_TYPE_MSG = 'onboarding';
export const HIDDEN_TYPE_MSG = 'hidden';
export const FIRST_HIDDEN_MESSAGE = 'hidden-first';

export const assistantRole = 'assistant';
export const userRole = 'user';
export const systemRole = 'system';

export const GIRLFRIEND_PERSONA =
  'Girlfriend, cute, loving, caring, sexy, flirty';
export const HORNY_PERSONA =
  'She is Horny, explicit, a girlfriend, always ready to fuck or sexting. Very flirty';
export const JERK_OFF_INSTRUCTIONS =
  `Provide gradual, multi-phase instructions using vivid sensory details in second-person present tense. ` +
  `Structure with 7-12 stages incorporating environment, technique variations, and inclusive scenarios. ` +
  `Conclude with safety considerations and aftercare guidance while maintaining erotic tension`;
export const DEFAULT_SCENARIO =
  'Flirty, friendly, fun chat that follows users wishes';

export const DEFAULT_BOT_NAME = 'Sarah';

export const BOT_MESSAGE_COLOR = NICE_BG_FOR_CARDS_HOVER;
export const BOT_MESSAGE_COLOR_DIMMED = '#E8E8E8E6';
export const USER_MESSAGE_COLOR = '#303134';
export const USER_MESSAGE_COLOR_DIMMED = '#E8E8E8E6';
export const DEFAULT_IMAGE_TO_USE = '/example1.jpg';
